import { render, staticRenderFns } from "./buttongroup.vue?vue&type=template&id=4ca2ad0e&scoped=true"
import script from "./buttongroup.vue?vue&type=script&lang=js"
export * from "./buttongroup.vue?vue&type=script&lang=js"
import style0 from "./buttongroup.vue?vue&type=style&index=0&id=4ca2ad0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2ad0e",
  null
  
)

export default component.exports